import axios from "axios";
import { useState, useEffect } from "react";
import Loader from "../../../../components/loader/Loader";
import { PostItem } from "../../../../components/posts/PostItem";
import LoadingHero from "../../../../assets/Assetstest/forumhero1.png";
import fishmonsterImage from "../../../../assets/Assetstest/fishmonster.png"; // Import the fishmonster.png image
import "../../forum.css";

export interface Post {
  _id: string;
  title: string;
  description: string;
  thumbnail: string | null;
  category: string;
  creator: { _id: string; name: string };
  createdAt: string;
  likes: string[];
}

export const Lfg = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    const fetchLfgPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/posts/lfg?page=${page}`
        );
        setPosts(response.data.posts || []);
        setTotalPages(response.data.totalPages || 1);
      } catch (error) {
        console.error("API Error:", error);
        setPosts([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLfgPosts();
  }, [page]);

  const handleNextPage = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePreviousPage = () => {
    if (page > 1) setPage(page - 1);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <section className="posts">
      <div id="forum__hero">
        <img src={LoadingHero} alt="hero image RISEV2" />
        <section id="forum__body">
          <div id="forum">
            <div className="forum__title">
              <h1>Looking for Guild</h1>
            </div>

            <section className="forum__list">
              {posts.length > 0 ? (
                posts.map(
                  ({
                    _id: id,
                    title,
                    description,
                    thumbnail,
                    category,
                    creator,
                    createdAt,
                    likes,
                  }) => {
                    return (
                      <PostItem
                        key={id}
                        postID={id}
                        thumbnail={
                          thumbnail ? (
                            <img src={thumbnail} alt="User Avatar" />
                          ) : (
                            <img
                              src={fishmonsterImage}
                              alt="Fish Monster"
                              width={40}
                              height={40}
                            />
                          )
                        }
                        category={category}
                        title={title}
                        description={description}
                        playerID={creator?._id || "Unknown"}
                        createdAt={createdAt}
                        creator={creator}
                        repliesCount={likes.length || 0}
                        viewsCount={0}
                        lastReplier={"No replies"}
                        lastReplierAvatar={""}
                        lastReplyTime={new Date(createdAt).toLocaleTimeString()}
                      />
                    );
                  }
                )
              ) : (
                <h2 className="center">No Guilds Found</h2>
              )}
            </section>

            <div className="pagination">
              <button onClick={handlePreviousPage} disabled={page === 1}>
                Previous
              </button>
              <span>
                Page {page} of {totalPages}
              </span>
              <button onClick={handleNextPage} disabled={page === totalPages}>
                Next
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};
